<h1 mat-dialog-title>Search device</h1>
<div mat-dialog-content>
  <mat-form-field hintLabel="Min 5 characters" class="example-full-width">
    <mat-label>MAC address</mat-label>
    <input matInput placeholder="MAC address" (input)="onChange($event.target['value'])">
  </mat-form-field>
  <div>
    <table class="table" mat-table [dataSource]="devices$ | async">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
      </ng-container>
      <ng-container matColumnDef="mac">
        <th mat-header-cell *matHeaderCellDef> MAC </th>
        <td mat-cell *matCellDef="let element"> {{ element.attributes.macAddress }} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['name','mac']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['name','mac'];"
      (click)="selectDevice(row)"></tr>
    </table>
    @if (isLoading) {
      <mat-progress-spinner class="auto-center" mode="indeterminate" color="primary" [diameter]="40"></mat-progress-spinner>
    }
  </div>
</div>

<div mat-dialog-actions>
  <lib-button variant="stroked" color="primary" mat-dialog-close>Cancel</lib-button>
</div>